<template>
  <div
    class="tw-relative tw-w-full tw-font-inter"
  >
    <!-- Input -->
    <div class="tw-relative tw-flex tw-items-center">
      <i class="fas fa-search tw-absolute tw-left-3 tw-text-gray-400" />
      <input
        v-model="searchQuery"
        type="text"
        :placeholder="placeholder"
        :class="[
          'tw-w-full tw-p-2 tw-pl-10 ',
          'focus:tw-outline-none',
          'tw-rounded-lg tw-bg-[#F6F7F8]',
          'tw-border tw-border-solid tw-border-[#DFE2E7]',
          'tw-text-base tw-text-gray-800'
        ]"
        @input="handleTyping"
        @focus="showDropdown = true"
      >
    </div>

    <!-- Results -->
    <div
      v-if="showDropdown"
      :class="[
        'tw-absolute tw-z-10 tw-inset-x-0 tw-mt-1',
        'tw-rounded-lg tw-bg-[#F6F7F8] tw-shadow-lg',
      ]"
    >
      <ul class="tw-max-h-52 tw-overflow-y-auto">
        <li
          v-for="(item, index) in combinedResults"
          :key="index"
          class="tw-text-gray-800 tw-p-2 tw-cursor-pointer hover:tw-bg-gray-200 tw-flex tw-items-center"
          @click="selectItem(item)"
        >
          <!-- Icon -->
          <i
            :class="getIconClass(item.entity_type)"
            class="tw-mr-2"
          />
          <!-- Text -->
          <div>
            <p>{{ item.name }}</p>
            <p v-if="!item.ticker_id">
              Created:
              {{ new Date(item.created_at).toLocaleString('en-US', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false
              }) }}
            </p>
          </div>
        </li>
      </ul>

      <!-- Loading Spinner -->
      <div
        v-if="isTyping || isSearching"
        class="tw-text-gray-800 tw-p-2"
      >
        <i class="fas fa-spinner tw-animate-spin tw-text-gray-800" />
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    placeholder: {
      type: String,
      default: 'Search...',
    },
    portfolioParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isFocused: false,
      showDropdown: false,
      defaultResults: [],
      searchResults: [],
      searchQuery: '',
      pendingQuery: '',
      isTyping: false,
      isSearching: false,
      typingTimeout: null,
      searchTimeout: null,
    };
  },
  computed: {
    filteredDefaultResults() {
      return this.defaultResults.filter(item =>
        item.name.toLowerCase().includes(this.searchQuery.toLowerCase()),
      );
    },
    combinedResults() {
      // Combine local and API results first
      const allResults = [...this.filteredDefaultResults, ...this.searchResults];

      // Then apply sorting logic to the combined results
      const exactMatches = allResults.filter(item =>
        item.name.toLowerCase() === this.searchQuery.toLowerCase(),
      );
      const startsWithMatches = allResults.filter(item =>
        item.name.toLowerCase().startsWith(this.searchQuery.toLowerCase()) &&
        item.name.toLowerCase() !== this.searchQuery.toLowerCase(),
      );
      const partialMatches = allResults.filter(item =>
        item.name.toLowerCase().includes(this.searchQuery.toLowerCase()) &&
        !item.name.toLowerCase().startsWith(this.searchQuery.toLowerCase()),
      );

      return [...exactMatches, ...startsWithMatches, ...partialMatches];
    },
  },
  created() {
    this.getDefaultPortfolios();
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    getIconClass(entityType) {
      if (entityType.includes('Portfolio')) {
        return 'fas fa-chart-pie tw-text-info';
      }
      return 'fas fa-user-friends tw-text-warning';
    },
    async getDefaultPortfolios() {
      this.defaultResults = await this.getPortfolios();
    },
    async searchPortfolios() {
      this.pendingQuery = this.searchQuery;
      const results = await this.getPortfolios(this.searchQuery);
      if (!this.searchQuery) {
        this.searchResults = [];
        return;
      }
      if (this.pendingQuery === this.searchQuery) {
        this.searchResults = results;
      }
    },
    async getPortfolios(query='') {
      this.isSearching = true;
      console.log('Searching...', query);
      const params = {
        search: query,
        return_entities: true,
        ...this.portfolioParams,
      };

      const res = await fetch(`/api/v1/portfolios/?${new URLSearchParams(params)}`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      const data = await res.json();
      this.isSearching = false;
      console.log('Done searching...');
      return data?.portfolios || [];
    },
    handleTyping(event) {
      if (this.isTyping) return;

      this.isTyping = true;
      clearTimeout(this.typingTimeout);

      this.typingTimeout = setTimeout(() => {
        this.isTyping = false;
        this.searchPortfolios();
      }, 500);
    },
    selectItem(item) {
      this.searchQuery = '';
      this.showDropdown = false;
      this.$emit('selected', item);
    },
    handleClickOutside(event) {
      const dropdown = this.$el.querySelector('ul');
      const input = this.$el.querySelector('input');
      if (dropdown && !dropdown.contains(event.target) && !input.contains(event.target)) {
        this.showDropdown = false;
      }
    },
  },
};
</script>

<style scoped>
</style>
